import { ChangePasswordRequest } from "../requests/changePasswordRequest"
import { CreateUserRequest } from "../requests/createUserRequest"
import { SignInRequest } from "../requests/signInRequest"
import { AuthenticationResponse } from "../responses/authenticationResponse"
import { AxiosInstance } from "axios"

export class AuthenticationApi {
  private sicalcClient: AxiosInstance

  constructor(sicalcClient: AxiosInstance) {
    this.sicalcClient = sicalcClient
  }
  public async signIn(request: SignInRequest) {
    const url = `/api/v1/identity/sign-in`
    const response = await this.sicalcClient.post<AuthenticationResponse>(url, request)
    return response.data
  }

  /** obs! The new user cannot sign in until an admin has approved them */
  public async createUser(request: CreateUserRequest) {
    const url = `/api/v1/identity/register`
    await this.sicalcClient.post(url, request)
  }

  /** Null for users registered before companies were introduced */
  public async getCompanyIdForUser(userId: string) {
    const url = `/api/v1/identity/users/${userId}/company`
    const response = await this.sicalcClient.get<string | null>(url)
    // ASP.NET answers 204 with an empty body when the value is null
    return response.data || null
  }

  public async getValidRoles() {
    const url = `/api/v1/identity/valid-roles`
    const response = await this.sicalcClient.get<string[]>(url)
    return response.data
  }

  public async changePassword(request: ChangePasswordRequest) {
    const url = `/api/v1/identity/change-password`
    await this.sicalcClient.post(url, request)
  }
}

